<template>
  <modelframe>
    <div class="addUser">
      <el-form :model="userData" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="用户名" prop="password">
          <el-input type="text" v-model="userData.password" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="用户密码" prop="newPassword">
          <el-input type="password" v-model="userData.newPassword" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="checkPassword">
          <el-input type="password" v-model.number="userData.checkPassword" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="手机号码" prop="checkPassword">
          <el-input type="number"  v-model.number="userData.checkPassword" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('userData')">提交</el-button>
          <el-button @click="resetForm('userData')">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
  </modelframe>
</template>

<script>
export default {
  name: "modifyPassword",
  data(){
    let validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入原密码'));
      } else {
        callback();
      }
    };
    let validateNewPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入新密码'));
      } else {
        this.$refs.ruleForm.validateField('checkPassword');
        callback();
      }
    };
    let validateCheckPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value.toString() !== this.userData.newPassword) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      userData: {
        password: '',
        newPassword: '',
        checkPassword: ''
      },
    rules: {
      password: [
        { validator: validatePass, trigger: 'blur' }
      ],
      newPassword: [
        { validator: validateNewPass, trigger: 'blur' }
      ],
      checkPassword: [
        { validator: validateCheckPass, trigger: 'blur' }
      ]
    }
    }
  },
  methods:{
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert('submit!');
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
}
</script>

<style scoped>
  .addUser{
    position: relative;
    margin:auto;
    top: 30px;
    text-align: center  ;
    vertical-align: center;
    width: 400px;
    height:fit-content;
    padding-bottom: 35px;
  }
</style>
